import React from 'react';
import Box from '@mui/material/Box';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';

const Footer = () => {
	return (
		<Box>
			<Box marginBottom={4}>
				<SimTypography variant='h3' sx={{ fontWeight: 700 }} align={'center'}>
					Didn't find what you are looking for?
				</SimTypography>
			</Box>
			<Box
				display='flex'
				flexDirection={{ xs: 'column', sm: 'row' }}
				justifyContent={'center'}
				alignItems={{ xs: 'stretched', sm: 'center' }}>
				<Box
					component={SimButton}
					href={'/contact'}
					variant='outlined'
					color='primary'
					size='large'
					marginTop={{ xs: 1, sm: 0 }}
					marginLeft={{ sm: 2 }}>
					Write to Us
				</Box>
			</Box>
		</Box>
	);
};

export { Footer };
